import Link from "next/link";
import Image from "next/image";
import { mcn } from "../utils";
import teamsIcon from "../public/images/icon-logo-teams.png";
import { IconIconExternal } from "./Icons";

type Props = {
  url: string | null;
  isEciuTeams: boolean;
  disabled: boolean;
};

export const WorkspaceLinkCard = ({ url, isEciuTeams, disabled }: Props) => {
  const className = mcn(
    "group block",
    "bg-light-blue",
    "p-8 rounded-2",
    "flex justify-center items-center gap-md"
  );
  if (url === null) {
    return (
      <div className={mcn(className)}>
        <p className={"text-style-body2 italic"}>No workspace available</p>
      </div>
    );
  }

  const linkClassNames = mcn(
    className,
    "focus-visible:default-focus",
    disabled && "opacity-50",
    disabled && "cursor-default"
  );
  const shortUrl = new URL(url).hostname;
  const label = isEciuTeams ? "Go to Teams channel" : `Go to ${shortUrl}`;
  return (
    <Link
      href={url}
      target="_blank"
      rel="noreferrer"
      className={linkClassNames}
    >
      {isEciuTeams && (
        <Image src={teamsIcon} alt="" className="flex-shrink-0" />
      )}
      <span className="text-style-subtitle1">
        <span
          className={mcn(
            !disabled && "underline",
            "group-hover:no-underline",
            "group-focus-visible:no-underline"
          )}
        >
          {label}
        </span>{" "}
        <IconIconExternal className="inline" />
      </span>
    </Link>
  );
};
